import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\"><path d=\"M268.972 114.318c73.212 0 132.56 59.348 132.56 132.56v530.243c0 73.213-59.348 132.561-132.56 132.561s-132.56-59.348-132.56-132.56V246.878c0-73.213 59.348-132.561 132.56-132.561zm486.056 0c73.212 0 132.56 59.348 132.56 132.56v530.243c0 73.213-59.348 132.561-132.56 132.561s-132.56-59.348-132.56-132.56V246.878c0-73.213 59.348-132.561 132.56-132.561z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol